"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notification = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_dom_1 = tslib_1.__importStar(require("react-dom"));
var config_context_1 = require("../_util/config-context");
var button_1 = require("../button");
var justify_1 = require("../justify");
var icon_1 = require("../icon");
var text_1 = require("../text");
var configprovider_1 = require("../configprovider");
var use_visible_transition_1 = require("../_util/use-visible-transition");
var call_both_1 = require("../_util/call-both");
var noop_1 = require("../_util/noop");
var util_1 = require("./util");
var getPlainText_1 = require("../_util/getPlainText");
var use_isomorphic_layout_effect_1 = require("../_util/use-isomorphic-layout-effect");
var i18n_1 = require("../i18n");
var themeMap = {
    // type: [icon, theme]
    success: ["success", "success"],
    warning: ["warning", "warning"],
    error: ["error", "danger"],
};
var Notification = react_1.forwardRef(function NotificationShow(_a, ref) {
    var _b;
    var type = _a.type, title = _a.title, extra = _a.extra, description = _a.description, footer = _a.footer, _c = _a.duration, duration = _c === void 0 ? 5000 : _c, className = _a.className, style = _a.style, _d = _a.onClose, onClose = _d === void 0 ? noop_1.noop : _d, _e = _a.onClick, onClick = _e === void 0 ? noop_1.noop : _e, onFooterClick = _a.onFooterClick;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var t = i18n_1.useTranslation();
    var _f = tslib_1.__read(react_1.useState(false), 2), visible = _f[0], setVisible = _f[1];
    var timerRef = react_1.useRef(null);
    react_1.useImperativeHandle(ref, function () { return ({
        setVisible: setVisible,
        renew: function () {
            clearTimeout(timerRef.current);
            if (visible && duration !== 0) {
                timerRef.current = setTimeout(function () { return setVisible(false); }, duration);
            }
        },
    }); });
    // 渲染之后，马上显示
    react_1.useEffect(function () {
        setVisible(true);
        return function () { return clearTimeout(timerRef.current); };
    }, []);
    use_isomorphic_layout_effect_1.useIsomorphicLayoutEffect(function () {
        clearTimeout(timerRef.current);
        if (visible && duration !== 0) {
            timerRef.current = setTimeout(function () { return setVisible(false); }, duration);
        }
    }, [duration, visible]);
    var _g = use_visible_transition_1.useVisibleTransition(visible), shouldContentEnter = _g.shouldContentEnter, shouldContentRender = _g.shouldContentRender, onContentExit = _g.onContentExit;
    if (!shouldContentRender) {
        return null;
    }
    var hasHeader = !!title || !!extra;
    var _h = tslib_1.__read(themeMap[type] || themeMap.success, 2), icon = _h[0], theme = _h[1];
    var content = (react_1.default.createElement(util_1.NotificationTransition, { in: shouldContentEnter, onExited: call_both_1.callBoth(onClose, onContentExit) },
        react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-notification", classPrefix + "-notification--" + type, className), style: style, onMouseEnter: function () { return clearTimeout(timerRef.current); }, onMouseLeave: function () {
                if (duration !== 0) {
                    timerRef.current = setTimeout(function () { return setVisible(false); }, duration);
                }
            }, onClick: onClick },
            react_1.default.createElement("div", { className: classPrefix + "-notification__close" },
                react_1.default.createElement(button_1.Button, { type: "icon", icon: "close", htmlType: "button", onClick: function () {
                        setVisible(false);
                    }, "aria-label": t.closeText })),
            hasHeader && (react_1.default.createElement("div", { className: classPrefix + "-notification__header" },
                react_1.default.createElement(justify_1.Justify, { left: react_1.default.createElement("div", { className: classPrefix + "-notification__header-title" }, title), right: react_1.default.createElement("div", { className: classPrefix + "-notification__header-sub-info" }, extra) }))),
            react_1.default.createElement("div", { className: classPrefix + "-notification__body" },
                react_1.default.createElement(icon_1.Icon, { type: icon }),
                react_1.default.createElement(text_1.Text, { theme: theme, className: classPrefix + "-notification__text", parent: "div" }, description)),
            !!footer && (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-notification__footer", (_b = {},
                    _b[classPrefix + "-notification__footer--link"] = onFooterClick,
                    _b)), onClick: onFooterClick || noop_1.noop }, onFooterClick ? (react_1.default.createElement(justify_1.Justify, { left: react_1.default.createElement(text_1.Text, { theme: "label", className: classPrefix + "-fz-reset", parent: "div" }, footer), right: react_1.default.createElement(icon_1.Icon, { type: "arrowright--line" }) })) : (footer))))));
    return react_dom_1.createPortal(content, util_1.getRoot(classPrefix));
});
Notification.displayName = "Notification";
var showMethod;
/**
 * API 的方式显示通知
 */
function show(type, _a) {
    if (type === void 0) { type = "success"; }
    if (_a === void 0) { _a = {}; }
    var _b = _a.onClose, onClose = _b === void 0 ? noop_1.noop : _b, _c = _a.onExited, onExited = _c === void 0 ? noop_1.noop : _c, options = tslib_1.__rest(_a, ["onClose", "onExited"]);
    if (typeof showMethod === "function") {
        return showMethod(type, options);
    }
    var el = document.createElement("div");
    var instanceRef = react_1.default.createRef();
    var show = function () {
        react_dom_1.default.render(react_1.default.createElement(configprovider_1.ConfigProvider, null,
            react_1.default.createElement(Notification, tslib_1.__assign({}, options, { type: type, ref: instanceRef, onClose: function () {
                    onClose();
                    onExited();
                    react_dom_1.unmountComponentAtNode(el);
                } }))), el);
    };
    var hide = function () {
        if (instanceRef.current) {
            instanceRef.current.setVisible(false);
        }
    };
    var renew = function () {
        if (instanceRef.current) {
            instanceRef.current.renew();
        }
    };
    var handle = {
        hide: hide,
        renew: renew,
        destroy: hide,
    };
    util_1.limit({
        show: show,
        hide: hide,
        renew: renew,
        isExisted: function () { return !!instanceRef.current; },
        identifier: options.unique
            ? [
                type,
                getPlainText_1.getPlainText(options.title),
                getPlainText_1.getPlainText(options.description),
                getPlainText_1.getPlainText(options.extra),
                getPlainText_1.getPlainText(options.footer),
            ].join("$")
            : null,
    });
    return handle;
}
exports.notification = {
    success: function (options) { return show("success", options); },
    warning: function (options) { return show("warning", options); },
    error: function (options) { return show("error", options); },
};
// eslint-disable-next-line dot-notation
exports.notification["setShowMethod"] = function (method) {
    showMethod = method;
};
//# sourceMappingURL=Notification.js.map